module.exports = __webpack_public_path__ + "static/media/government.de3555d6.png";